export const AppliedPaymentPlanHeading = "payment-plan";

export const AppliedBalanceHeading = "applied-balance";